<template>
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col">
        <h4 class="m-0 d-flex align-items-center">
          <nobr>
            <ClipboardList :size="24" style="vertical-align: middle; margin-right: 8px;" />
            Requests
          </nobr>
          <span 
            data-v-if="recentDraftCount > 0"
            class="badge bg-warning text-dark ms-3"
            style="cursor: pointer; font-size: 0.6em;"
            @click="filterRecentDrafts"
            :title="`${recentDraftCount} draft request(s) created in the last 7 days — click to filter`"
          >
            {{ recentDraftCount }} Recent{{ recentDraftCount !== 1 ? '' : '' }}
          </span>
          <span 
            data-v-if="oldDraftCount > 0"
            class="badge bg-danger ms-2"
            style="cursor: pointer; font-size: 0.6em;"
            @click="filterOldDrafts"
            :title="`${oldDraftCount} draft request(s) older than 7 days — click to filter`"
          >
            {{ oldDraftCount }} Stale{{ oldDraftCount !== 1 ? '' : '' }}
          </span>
        </h4>
      </div>
      <div class="col-3 text-end">
        <div class="btn-group">
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { ClipboardList } from 'lucide-vue-next';
import Api from '@/services/ApiService';
import Emitter from '@/services/Emitter';

const recentDraftCount = ref(0);
const oldDraftCount = ref(0);

const getOneWeekAgo = (): Date => {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    date.setHours(0, 0, 0, 0);
    return date;
};

const loadDraftCounts = async () => {
    try {
        const oneWeekAgo = getOneWeekAgo();

        // Recent drafts (created within the last 7 days)
        const recentResponse = await Api.loadWorkOrders({
            Status: [0],
            Title: 'Request',
            StartDate: oneWeekAgo,
            Size: 1,
            Page: 0
        }, true);
        recentDraftCount.value = recentResponse.Meta?.Total || 0;

        // Stale drafts (created more than 7 days ago)
        const oldResponse = await Api.loadWorkOrders({
            Status: [0],
            Title: 'Request',
            EndDate: oneWeekAgo,
            Size: 1,
            Page: 0
        }, true);
        oldDraftCount.value = oldResponse.Meta?.Total || 0;
    } catch (error) {
        console.error('Failed to load draft counts:', error);
    }
};

const filterRecentDrafts = () => {
    Emitter.emit('request:filter-drafts', 'recent');
};

const filterOldDrafts = () => {
    Emitter.emit('request:filter-drafts', 'stale');
};

// Refresh counts when datatable data changes
let unsubRefresh: Function | null = null;

onMounted(() => {
    loadDraftCounts();
    unsubRefresh = Emitter.on('datatable-refresh', () => {
        // Small delay to let the datatable finish its reload
        setTimeout(loadDraftCounts, 500);
    });
});

onUnmounted(() => {
    if (unsubRefresh) unsubRefresh();
});
</script>
